
















































































import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {NTag} from "@/types/ntag";
import TimestampAgo from "@/components/TimestampAgo.vue";
import moment from "moment";
import * as _ from "lodash";
import fileDownload from "js-file-download";
import CustomSectionHeader from "@/components/CustomSectionHeader.vue";
import VueError from "@/components/VueError.vue";
import Loading from "@/components/Loading.vue";
import tippy from "tippy.js";

@Component({
  components: {
    TimestampAgo,
    CustomSectionHeader,
    VueError,
    Loading,
  }
})
export default class LocationTagsList extends Vue {
  @Prop({ default: '', type: String}) locationId!: string;
  @Prop({ default: '', type: String}) locationName!: string;
  @Prop({ default: () => {return []},  type: Array}) tags!: NTag[];

  error:string = '';
  httpBusy:boolean = false;
  offset = 0;
  itemsPerPage = 10;

  mounted() {
    tippy('[data-tippy-content]');
  }

  async exportLocationTags() {
    const csvExport = this.tagsToCSV(this.tags.concat());

    const filename = `export-location-${this.locationId}-ntags-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  private tagsToCSV(tags: NTag[]): string {
    const retList:string[] = [];

    retList.push(`tagId,name,enterpriseId,currentLocation,lastOnline,sku,temperature,groups`);

    for(const tag of tags) {

      const row = [];
      row.push(this.forceString(tag.id));
      row.push(this.forceString(tag.name ?  tag.name : ''));
      row.push(this.forceString(tag.enterpriseId.replace(/^nnn\./, '')));
      row.push(this.forceString(this.locationName ? this.locationName as string : ''));
      row.push(moment(tag.lastOnline).format());
      row.push(tag.sku ? tag.sku : '');
      row.push(tag.temperature ? tag.temperature : '');
      row.push(this.forceString(_.map(
          _.filter(tag.groups, groupId => !groupId.endsWith('master')),
          groupId => groupId.replace(/^nnn\./, ''))
          .join("|")));

      retList.push(row.join(','));
    }

    return retList.join("\n");
  }

  private forceString(data:string):string {
    return `"${data}"`;
  }

  goBack() {
    this.offset+=this.itemsPerPage;
  }

  goForward() {
    this.offset-=this.itemsPerPage;
  }

  getEnterprise(tag: NTag): string {
    return tag.enterpriseId.replace(/^nnn\./,'');
  }

  goToTagPage(tagId:string) {
    this.$router.push(`/applications/ntag/tags/${tagId}`);
  }

  get showItemsTable() {
    return !this.httpBusy && this.tags.length > 0;
  }

  get showItemsNav() {
    return !this.httpBusy && this.tags.length > 0;
  }

  get showNoItems() {
    return !this.httpBusy && this.tags.length === 0;
  }

  get olderItemsEnabled() {
    return (this.offset + this.itemsPerPage) < this.tags.length;
  }

  get newerItemsEnabled() {
    return this.offset > 0;
  }
}
